import fetch from '@/utils/fetch'
/**
 * 获取地址列表
 */
export function getAddressList(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/useraddress/getaddresslist',
    method: 'post',
    data
  })
}
/**
 * 获取地址详情
 */
export function getAddressItem(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/useraddress/getaddress',
    method: 'post',
    data
  })
}
/**
 * 添加收货地址
 */
export function addAddress(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/useraddress/create',
    method: 'post',
    data
  })
}

/**
 * 修改地址列表
 */
export function updateAddress(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/useraddress/update',
    method: 'post',
    data
  })
}

/**
 * 删除地址列表
 */
export function deleteAddress(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/useraddress/delete',
    method: 'post',
    data
  })
}

/**
 * 置顶收货地址
 */
export function setTopAddress(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/useraddress/updateusetime',
    method: 'post',
    data
  })
}
